import React, { useState } from 'react';
import { Outlet, Link, useNavigate, useLocation, Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './AdminLayout.css';

const AdminLayout = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);
  const volunteer = user?.desk_role === 'volunteer';

  const handleLogout = async () => {
    await logout();
    navigate('/');
  };

  const closeMenu = () => setMenuOpen(false);
  const path = location.pathname;
  const volunteerAllowed = path === '/admin/check-in' || path === '/admin/gifts';

  if (volunteer && !volunteerAllowed) {
    return <Navigate to="/admin/check-in" replace />;
  }

  return (
    <div className={`admin-layout${menuOpen ? ' menu-open' : ''}`}>
      <button
        type="button"
        className="admin-mobile-menu-toggle"
        onClick={() => setMenuOpen(!menuOpen)}
        aria-label={menuOpen ? '關閉選單' : '開啟選單'}
        aria-expanded={menuOpen}
      >
        {menuOpen ? '✕' : '☰'}
      </button>

      <div className={`admin-sidebar ${menuOpen ? 'open' : ''}`}>
        <div className="sidebar-header">
          <h2>管理面板</h2>
          <p>{volunteer ? '義工' : `管理員：${user?.phone_number || ''}`}</p>
          <button type="button" className="admin-sidebar-close" onClick={closeMenu} aria-label="關閉選單">
            ✕
          </button>
        </div>
        <nav className="sidebar-nav">
          {volunteer ? (
            <>
              <Link to="/admin/check-in" onClick={closeMenu}>簽到</Link>
              <Link to="/admin/gifts" onClick={closeMenu}>禮品</Link>
            </>
          ) : (
            <>
              <Link to="/admin" onClick={closeMenu}>儀表板</Link>
              <Link to="/admin/check-in" onClick={closeMenu}>簽到</Link>
              <Link to="/admin/gifts" onClick={closeMenu}>禮品</Link>
              <Link to="/admin/events" onClick={closeMenu}>活動</Link>
              <Link to="/admin/members" onClick={closeMenu}>會員管理</Link>
              <Link to="/admin/content" onClick={closeMenu}>內容管理</Link>
              <Link to="/admin/messages" onClick={closeMenu}>聯絡訊息</Link>
              <Link to="/admin/advanced" onClick={closeMenu}>進階設定</Link>
            </>
          )}
          <hr />
          <Link to="/" onClick={closeMenu}>返回首頁</Link>
          <button type="button" onClick={handleLogout} className="btn btn-secondary">登出</button>
        </nav>
      </div>

      {menuOpen && <div className="admin-sidebar-overlay" onClick={closeMenu} />}

      <div className="admin-content">
        <Outlet />
      </div>
    </div>
  );
};

export default AdminLayout;
